module.exports = __webpack_public_path__ + "img/Duck.a20a512c.jpg";